import axios from "../../api/axios";
import { useQuery } from "react-query";
import { ProfileInfo } from "../types/profileInfo";

export const fetchProfileInfo = async (): Promise<ProfileInfo> => {
  // Read the key fresh each time the function is called
  //@ts-ignore
  const key = JSON.parse(window.localStorage?.getItem("authkey") || 'null');
  
  const { data } = await axios.get("/profile",
    {
      headers: {
        'Authorization': 'Bearer ' + key,

      }
    });
  return data;
};

export function useProfileInfo() {
  return useQuery("profile-info", () => fetchProfileInfo());
}
